import { useTranslation } from 'react-i18next';
import { useUIStore } from '@/stores';
import type { Language } from '@/stores/ui-store';

/**
 * Hook that provides theme and language management functionality.
 * Consolidates common logic used in AppHeader and AppSidebar.
 */
export function useThemeAndLanguage(): {
  readonly theme: 'light' | 'dark';
  readonly language: Language;
  readonly toggleTheme: () => void;
  readonly changeLanguage: (value: Language) => void;
} {
  const { i18n } = useTranslation('common');
  const { theme, setTheme, language, setLanguage } = useUIStore();

  const toggleTheme = () => {
    setTheme(theme === 'light' ? 'dark' : 'light');
  };

  const changeLanguage = (value: Language) => {
    if (language === value) return;
    void i18n.changeLanguage(value);
    setLanguage(value);
  };

  return {
    theme,
    language,
    toggleTheme,
    changeLanguage,
  };
}
